import React, { useEffect } from "react";
import { Box } from "@mui/material";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { getSignedinState, getSigninClear } from "../selectors";
import { ClientHeader } from "components/ClientHeader";

interface ClientLayoutProps {
  children: React.ReactNode;
}

export const ClientLayout: React.FC<ClientLayoutProps> = ({ children }) => {
  const history = useHistory();
  const signedInState = useSelector(getSignedinState);
  const clear = useSelector(getSigninClear);

  useEffect(() => {
    if (signedInState === false && clear) {
      history.replace("/");
    }
  }, [signedInState, clear, history]);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100vh" }}>
      <ClientHeader />
      <Box sx={{ flex: 1, overflow: "auto" }}>{children}</Box>
    </Box>
  );
};
